import { Message } from "../../../common/batchNotificationInterface";
import { v4 as uuidv4 } from "uuid";
import React, { useState } from "react";
import {
	Checkbox,
	TextField,
	Autocomplete,
} from "../../../common/MaterialComponent";
import { ContentTemplate } from "../../../models/BatchMessage/ContentTemplate";
import MessageSegmentPreview from "../MessageSegmentPreview/MessageSegmentPreview";
export interface TemplateSelectionProps {
	onTemplateChange: (value: Message) => void;
	isReadOnly: boolean;
	rowId: string;
	country: string;
	templates: ContentTemplate[];
}

const TemplateSelection = (props: TemplateSelectionProps) => {
	const [previewContent, setPreviewContent] = useState<string | null>(null);
	const selectTemplate = (event: any, value: ContentTemplate | null) => {
		if (value === null || !value.types["twilio/text"]) {
			setPreviewContent(null);
			return;
		}
		if (props.isReadOnly) return;
		const content = value.types["twilio/text"].body;
		setPreviewContent(content);
		props.onTemplateChange({
			id: uuidv4(), // unique id
			languageCode: value.language.split("_")[0],
			message: value.sid,
			audioDuration: 0,
			fileName: null,
		});
	};

	return (
		<>
			<Autocomplete
				onChange={selectTemplate}
				data-testid="templateSelection"
				options={props.templates ?? []}
				getOptionLabel={(option: ContentTemplate) => `${option.friendly_name}`}
				autoHighlight
				getOptionSelected={(option, value) => !value || option === value}
				getOptionDisabled={() => props.isReadOnly}
				renderOption={(option: ContentTemplate, { selected }) => {
					return (
						<React.Fragment>
							<Checkbox color="primary" checked={selected} />
							{`${option.language.split("_")[0]} - ${option.friendly_name}`}
						</React.Fragment>
					);
				}}
				renderInput={(params) => (
					<TextField
						data-testid="templateInput"
						value={params}
						{...params}
						label="Select a Template"
						disabled={props.isReadOnly}
					/>
				)}
			/>
			<br />
			{previewContent && (
				<MessageSegmentPreview
					messageContent={previewContent}
					index={""}
					textDirection={""}
					messageInputFocus={true}
					country={props.country}
					setShowBadVariableWarning={() => {}}
				/>
			)}
		</>
	);
};

export default TemplateSelection;
